
import Hero from './components/Hero';
import Services from './components/Services';
import Capabilities from './components/Capabilities';
import Safety from './components/Safety';

export default function Mining() {
  return (
    <div className="min-h-screen">
      <Hero />
      <Services />
      <Capabilities />
      <Safety />
    </div>
  );
}
